import React from "react";
import "./style.css";

export const CourseFAQ = ({ question, answer, isExpanded, onClick }) => {

  return (
    <div className="course_faq_answer_div">
      <div className="course_faq_question d-block rounded mx-auto px-3 py-2 my-2">

        <div className="d-flex justify-content-between cursor-pointer" onClick={onClick}>
          <div className="align-self-center question_p_margin_0" dangerouslySetInnerHTML={{ __html: question }}></div>

          <div className="align-self-center">
            <svg style={{ transition: 'transform .35s', transform: isExpanded ? 'scale(1, -1)' : '' }} className="faq_content_arrow" id="faq_content_1Vu1ErOg1bk5QCcY4ij9_arrow" xmlns="http://www.w3.org/2000/1svg" width="24" height="24" fill="#ffffff" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
            </svg>
          </div>
        </div>

        <div className={`course_faq_answer ${isExpanded ? 'active' : 'inactive'}`} dangerouslySetInnerHTML={{ __html: answer }}></div>

      </div>
    </div>
  );
};